// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__16q5v","title":"Error_title__34Ac6","subtitle":"Error_subtitle__3CLHI"};